module.exports = __webpack_public_path__ + "img/campagin-product1.40927cec.svg";